import { addLocation, removeLocation } from "./actions/locations";
import { trackSimpleEvent } from "../../shared/utils/reduxBeacon";

const gaEventsMap = {
  ...trackSimpleEvent(addLocation.type),
  ...trackSimpleEvent(removeLocation.type),
};

export default gaEventsMap;
